import React from 'react';
import { Button } from '@dotcom/crown-ui';
import { DialogCtaProps } from '../consumer-review-dialog-types';
import styles from '../consumer-review-dialog.module.scss';

export const ActionButton = ({ click, buttonText, isCheckboxChecked }: DialogCtaProps) => (
  <Button
    onClick={click}
    variant="primary"
    testId="action-button"
    disabled={!isCheckboxChecked}
    className={styles['button-text-transform']}
  >
    {buttonText}
  </Button>
);
